import { Component } from 'react';
import sharedStyles from '../single-page.module.scss';
import styles from './pantone-converter.component.module.scss';
import { genStyles } from '../converter-layout/generator-layout';

interface PantoneEntry {
    code: string;
    hex: string;
}

// Curated subset of the Pantone Solid Coated catalog. Full catalog is
// licensed; this list covers the most-referenced spot colors for general
// design / branding lookups. ~120 entries.
const PANTONE_CATALOG: PantoneEntry[] = [
    { code: '100 C', hex: '#F4ED7C' }, { code: '101 C', hex: '#F4ED47' },
    { code: '102 C', hex: '#FCE51A' }, { code: '103 C', hex: '#C6AD0F' },
    { code: '108 C', hex: '#FFD600' }, { code: '109 C', hex: '#FFD100' },
    { code: '116 C', hex: '#FFCD00' }, { code: '123 C', hex: '#FFC72C' },
    { code: '130 C', hex: '#F2A900' }, { code: '137 C', hex: '#FFA300' },
    { code: '144 C', hex: '#ED8B00' }, { code: '151 C', hex: '#FF8200' },
    { code: '158 C', hex: '#E87722' }, { code: '165 C', hex: '#FF671F' },
    { code: '172 C', hex: '#FA4616' }, { code: '179 C', hex: '#E03C31' },
    { code: '185 C', hex: '#E4002B' }, { code: '186 C', hex: '#C8102E' },
    { code: '187 C', hex: '#A6192E' }, { code: '188 C', hex: '#76232F' },
    { code: '192 C', hex: '#E03E52' }, { code: '199 C', hex: '#D50032' },
    { code: '200 C', hex: '#BA0C2F' }, { code: '201 C', hex: '#9D2235' },
    { code: '202 C', hex: '#862633' }, { code: '203 C', hex: '#ECB3CB' },
    { code: '212 C', hex: '#E0457B' }, { code: '213 C', hex: '#E0218A' },
    { code: '219 C', hex: '#DA1884' }, { code: '226 C', hex: '#D0006F' },
    { code: '233 C', hex: '#C5006B' }, { code: '240 C', hex: '#C5299B' },
    { code: '247 C', hex: '#BA0080' }, { code: '254 C', hex: '#971B2F' },
    { code: '261 C', hex: '#6D2077' }, { code: '262 C', hex: '#582C83' },
    { code: '266 C', hex: '#5F249F' }, { code: '267 C', hex: '#5F259F' },
    { code: '268 C', hex: '#582D40' }, { code: '273 C', hex: '#1B0088' },
    { code: '280 C', hex: '#012169' }, { code: '281 C', hex: '#00205B' },
    { code: '286 C', hex: '#0033A0' }, { code: '287 C', hex: '#003DA5' },
    { code: '288 C', hex: '#003087' }, { code: '293 C', hex: '#003DA5' },
    { code: '294 C', hex: '#002F6C' }, { code: '300 C', hex: '#005EB8' },
    { code: '301 C', hex: '#004B87' }, { code: '305 C', hex: '#59CBE8' },
    { code: '306 C', hex: '#00B5E2' }, { code: '312 C', hex: '#009ADA' },
    { code: '313 C', hex: '#0083A9' }, { code: '319 C', hex: '#2DCCD3' },
    { code: '320 C', hex: '#009CA6' }, { code: '326 C', hex: '#00A599' },
    { code: '327 C', hex: '#008578' }, { code: '335 C', hex: '#00664F' },
    { code: '341 C', hex: '#00754A' }, { code: '342 C', hex: '#006747' },
    { code: '348 C', hex: '#008542' }, { code: '349 C', hex: '#046A38' },
    { code: '354 C', hex: '#00B140' }, { code: '355 C', hex: '#009639' },
    { code: '361 C', hex: '#43B02A' }, { code: '362 C', hex: '#509E2F' },
    { code: '368 C', hex: '#78BE20' }, { code: '375 C', hex: '#97D700' },
    { code: '382 C', hex: '#C4D600' }, { code: '383 C', hex: '#A8AD00' },
    { code: '389 C', hex: '#D0DF00' }, { code: '396 C', hex: '#E2E868' },
    { code: '403 C', hex: '#BFB8AF' }, { code: '410 C', hex: '#867A6A' },
    { code: '417 C', hex: '#6E6F1F' }, { code: '424 C', hex: '#707372' },
    { code: '431 C', hex: '#5B6770' }, { code: '438 C', hex: '#3F2A30' },
    { code: '445 C', hex: '#333F48' }, { code: '452 C', hex: '#A7A8AA' },
    { code: '459 C', hex: '#E8D17A' }, { code: '466 C', hex: '#C1A875' },
    { code: '473 C', hex: '#F1B17A' }, { code: '480 C', hex: '#B19073' },
    { code: '487 C', hex: '#F3B3A6' }, { code: '494 C', hex: '#F3B3CE' },
    { code: '500 C', hex: '#F0BFCC' }, { code: '507 C', hex: '#D592AA' },
    { code: '514 C', hex: '#E5BEDB' }, { code: '521 C', hex: '#C9B2D6' },
    { code: '528 C', hex: '#B7A1E0' }, { code: '535 C', hex: '#9FAEE5' },
    { code: '542 C', hex: '#88BAE1' }, { code: '549 C', hex: '#88B0BC' },
    { code: '556 C', hex: '#8FB8A9' }, { code: '563 C', hex: '#86C8BC' },
    { code: '570 C', hex: '#88DBDF' }, { code: '577 C', hex: '#C6DC8B' },
    { code: '584 C', hex: '#DCE067' }, { code: '591 C', hex: '#D0DA45' },
    { code: '600 C', hex: '#F2EDA1' }, { code: '607 C', hex: '#EDE5BE' },
    { code: '614 C', hex: '#D9D399' }, { code: '621 C', hex: '#C5D6CD' },
    { code: '628 C', hex: '#BDE3F0' }, { code: '635 C', hex: '#9CDBE9' },
    { code: '642 C', hex: '#BFD7E8' }, { code: '649 C', hex: '#D3DDE9' },
    { code: '656 C', hex: '#D9E1F2' }, { code: '663 C', hex: '#E9E3DF' },
    { code: '670 C', hex: '#F2D8DE' }, { code: '677 C', hex: '#EBD2D8' },
    { code: '684 C', hex: '#D7BFC2' }, { code: '691 C', hex: '#D6BAB9' },
    { code: '698 C', hex: '#F4CDD4' }, { code: '705 C', hex: '#F8D2DE' },
    { code: '7406 C', hex: '#F1C400' }, { code: '7547 C', hex: '#131E29' },
    { code: 'Black C', hex: '#2D2926' }, { code: 'Cool Gray 1 C', hex: '#D9D9D6' },
    { code: 'Cool Gray 5 C', hex: '#B1B3B3' }, { code: 'Cool Gray 9 C', hex: '#75787B' },
    { code: 'Reflex Blue C', hex: '#001489' }, { code: 'Process Blue C', hex: '#0085CA' },
    { code: 'Process Yellow C', hex: '#FEDD00' }, { code: 'Process Magenta C', hex: '#D0006F' },
    { code: 'Process Cyan C', hex: '#0093D0' }, { code: 'Rhodamine Red C', hex: '#E10098' },
    { code: 'Rubine Red C', hex: '#CE0058' }, { code: 'Orange 021 C', hex: '#FE5000' },
    { code: 'Warm Red C', hex: '#F9423A' }, { code: 'Red 032 C', hex: '#EF3340' },
    { code: 'Yellow C', hex: '#FEDD00' },
];

function hexToRgb(hex: string): [number, number, number] | null {
    const m = hex.replace('#', '').match(/^([0-9a-f]{6}|[0-9a-f]{3})$/i);
    if (!m) return null;
    let h = m[0];
    if (h.length === 3) h = h.split('').map(c => c + c).join('');
    const v = parseInt(h, 16);
    return [(v >> 16) & 0xff, (v >> 8) & 0xff, v & 0xff];
}

// sRGB → linear → XYZ → CIE L*a*b* (D65). Allows Delta-E (CIE76) for
// perceptually meaningful colour distance — plain RGB Euclidean ranks
// neighbours by 256-cube geometry which doesn't match how the eye
// perceives similarity (e.g. saturates dark blues, miscalls pastels).
function rgbToLab(rgb: [number, number, number]): [number, number, number] {
    const srgbToLinear = (c: number) => {
        const v = c / 255;
        return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    };
    const [r, g, b] = rgb.map(srgbToLinear);
    // sRGB → XYZ (D65)
    const X = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    const Y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    const Z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    const f = (t: number) => t > 0.008856 ? Math.cbrt(t) : (7.787 * t) + 16 / 116;
    const L = 116 * f(Y) - 16;
    const a = 500 * (f(X) - f(Y));
    const bb = 200 * (f(Y) - f(Z));
    return [L, a, bb];
}

function distance(a: [number, number, number], b: [number, number, number]): number {
    const labA = rgbToLab(a);
    const labB = rgbToLab(b);
    return Math.sqrt(
        (labA[0] - labB[0]) ** 2 + (labA[1] - labB[1]) ** 2 + (labA[2] - labB[2]) ** 2
    );
}

interface State {
    direction: 'hex-to-pantone' | 'pantone-to-hex';
    hexInput: string;
    pantoneInput: string;
    copied: boolean;
}

export default class PantoneConverterComponent extends Component<{ feature?: string }, State> {
    private copyTimeout: ReturnType<typeof setTimeout> | null = null;
    state: State = {
        direction: 'hex-to-pantone',
        hexInput: '#6366f1',
        pantoneInput: 'Reflex Blue C',
        copied: false,
    };

    componentWillUnmount() {
        if (this.copyTimeout) clearTimeout(this.copyTimeout);
    }

    private get nearestPantone(): { entry: PantoneEntry; distance: number } | null {
        const rgb = hexToRgb(this.state.hexInput);
        if (!rgb) return null;
        let best: PantoneEntry = PANTONE_CATALOG[0];
        let bestDist = Infinity;
        for (const entry of PANTONE_CATALOG) {
            const r = hexToRgb(entry.hex);
            if (!r) continue;
            const d = distance(rgb, r);
            if (d < bestDist) { bestDist = d; best = entry; }
        }
        return { entry: best, distance: bestDist };
    }

    private get matchingHex(): PantoneEntry | null {
        const code = this.state.pantoneInput.trim().toLowerCase();
        if (!code) return null;
        return PANTONE_CATALOG.find(p => p.code.toLowerCase() === code) || null;
    }

    copyCode = (value: string) => {
        navigator.clipboard.writeText(value).then(() => {
            if (this.copyTimeout) clearTimeout(this.copyTimeout);
            this.setState({ copied: true });
            this.copyTimeout = setTimeout(() => this.setState({ copied: false }), 2000);
        });
    };

    render() {
        const { direction, hexInput, pantoneInput, copied } = this.state;
        const isHexToPantone = direction === 'hex-to-pantone';
        return (
            <div className="row">
                <div className="col-12">
                    <div className={styles.tabs}>
                        <button className={`${styles.tab} ${isHexToPantone ? styles.tabActive : ''}`}
                            onClick={() => this.setState({ direction: 'hex-to-pantone' })}>HEX → Pantone</button>
                        <button className={`${styles.tab} ${!isHexToPantone ? styles.tabActive : ''}`}
                            onClick={() => this.setState({ direction: 'pantone-to-hex' })}>Pantone → HEX</button>
                    </div>
                </div>
                {isHexToPantone ? (
                    <>
                        <div className="col-12 col-md-5">
                            <div className={genStyles.section}>
                                <label className={sharedStyles.label}>
                                    HEX color
                                    <div className={styles.colorRow}>
                                        <input type="color" value={hexInput}
                                            onChange={e => this.setState({ hexInput: e.target.value })} />
                                        <input className={styles.input} type="text" value={hexInput}
                                            onChange={e => this.setState({ hexInput: e.target.value })} />
                                    </div>
                                </label>
                                <p className={styles.note}>Match is nearest by perceptual distance (ΔE in CIE L*a*b*) from a ~135-color curated PMS Solid Coated subset.</p>
                            </div>
                        </div>
                        <div className="col-12 col-md-7">
                            <div className={genStyles.section}>
                                <label className={sharedStyles.label}>Closest Pantone match</label>
                                {this.nearestPantone ? (
                                    <div className={styles.resultCard}>
                                        <div className={styles.swatch} style={{ background: this.nearestPantone.entry.hex }} />
                                        <div>
                                            <div className={styles.code}>{this.nearestPantone.entry.code}</div>
                                            <div className={styles.hexLabel}>{this.nearestPantone.entry.hex}</div>
                                            <div className={styles.distance}>ΔE: {this.nearestPantone.distance.toFixed(1)} (smaller = closer match)</div>
                                        </div>
                                        <button className={`${sharedStyles.copyButton} ${copied ? sharedStyles.copyButtonSuccess : ''}`}
                                            onClick={() => this.copyCode(this.nearestPantone!.entry.code)}>
                                            {copied ? '✓ Copied' : 'Copy code'}
                                        </button>
                                    </div>
                                ) : <p className={styles.invalid}>Invalid HEX color.</p>}
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="col-12 col-md-5">
                            <div className={genStyles.section}>
                                <label className={sharedStyles.label}>
                                    Pantone code (e.g., "186 C", "Reflex Blue C")
                                    <input className={styles.input} type="text" value={pantoneInput}
                                        onChange={e => this.setState({ pantoneInput: e.target.value })} list="pantone-list" />
                                </label>
                                <datalist id="pantone-list">
                                    {PANTONE_CATALOG.map(p => <option key={p.code} value={p.code} />)}
                                </datalist>
                            </div>
                        </div>
                        <div className="col-12 col-md-7">
                            <div className={genStyles.section}>
                                <label className={sharedStyles.label}>HEX equivalent</label>
                                {this.matchingHex ? (
                                    <div className={styles.resultCard}>
                                        <div className={styles.swatch} style={{ background: this.matchingHex.hex }} />
                                        <div>
                                            <div className={styles.code}>{this.matchingHex.code}</div>
                                            <div className={styles.hexLabel}>{this.matchingHex.hex}</div>
                                        </div>
                                        <button className={`${sharedStyles.copyButton} ${copied ? sharedStyles.copyButtonSuccess : ''}`}
                                            onClick={() => this.copyCode(this.matchingHex!.hex)}>
                                            {copied ? '✓ Copied' : 'Copy HEX'}
                                        </button>
                                    </div>
                                ) : <p className={styles.invalid}>No match — try the dropdown or "100 C" style codes.</p>}
                            </div>
                        </div>
                    </>
                )}
            </div>
        );
    }
}
